import { ChildrenProps } from "@hex-insights/core";
import { useWizardNavigation, WizardNavigation } from "../../../../Components/WizardNavigation";

export enum ContractWizardPage {
	General,
	Services,
	PaymentSchedule,
	Review,
}

export function ContractWizardNavigation() {
	return (
		<WizardNavigation>
			<WizardNavigation.Button page={ContractWizardPage.General}>General</WizardNavigation.Button>
			<WizardNavigation.Button page={ContractWizardPage.Services}>Services</WizardNavigation.Button>
			<WizardNavigation.Button page={ContractWizardPage.PaymentSchedule}>Payment Schedule</WizardNavigation.Button>
			<WizardNavigation.Button page={ContractWizardPage.Review}>Review</WizardNavigation.Button>
		</WizardNavigation>
	);
}

const contractWizardPages = [
	ContractWizardPage.General,
	ContractWizardPage.Services,
	ContractWizardPage.PaymentSchedule,
	ContractWizardPage.Review,
];

ContractWizardNavigation.Router = function ({ children }: Partial<ChildrenProps>) {
	return <WizardNavigation.Router pages={contractWizardPages}>{children}</WizardNavigation.Router>;
};

ContractWizardNavigation.Route = WizardNavigation.Route;

export function useContractWizardNavigation() {
	return useWizardNavigation<ContractWizardPage>();
}
